export const EVENT_TABS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "tickets", label: "Tickets" },
  { key: "marketing", label: "Marketing" },
  { key: "attribution", label: "Attribution" },
  { key: "profit_and_loss", label: "Profit & Loss" },
  { key: "finances", label: "Finances" },
  { key: "offers", label: "Offers" },
  { key: "settlements", label: "Settlements" },
  { key: "show_details", label: "Show Details" },
  { key: "staffing", label: "Staffing" },
  { key: "assets", label: "Assets" },
  { key: "contacts", label: "Contacts" },
  { key: "notes", label: "Notes" },
];

export const DEFAULT_TAB = "dashboard";
export const TAB_KEYS = EVENT_TABS.map((t) => t.key);

// Holds have no ticketing/sales surface. Mirror the classic Hold page's sections,
// minus Settlements (product decision) and Show Details (Confirm-only classically).
export const HOLD_TAB_KEYS = [
  "dashboard",
  "profit_and_loss",
  "finances",
  "offers",
  "assets",
  "contacts",
  "notes",
];

export function tabsForType(type, { staffing = false, attribution = false } = {}) {
  if (type === "Hold") {
    const keys = staffing ? [...HOLD_TAB_KEYS, "staffing"] : HOLD_TAB_KEYS;
    return EVENT_TABS.filter((t) => keys.includes(t.key));
  }
  return attribution ? EVENT_TABS : EVENT_TABS.filter((t) => t.key !== "attribution");
}
